/**
 * #flair_svc.ts
 *
 * Code generated by ts-proto. DO NOT EDIT.
 * @packageDocumentation
 */
/* eslint-disable */
import _m0 from "protobufjs/minimal.js";
import { Empty } from "../../../../google/protobuf/empty.js";
import { JsonStatus } from "../common/common_msg.js";
import { ClearFlairTemplatesRequest, DeleteFlairRequest, DeleteFlairTemplateRequest, FlairArray, FlairConfigRequest, FlairCsvRequest, FlairCsvResponse, FlairListRequest, FlairListResponse, FlairObject, FlairRequest, FlairSelectorRequest, FlairSelectorResponse, FlairTemplateOrderRequest, FlairTemplateRequest, LinkFlairRequest, SelectFlairRequest, SetFlairEnabledRequest, } from "./flair_msg.js";
export const FlairServiceName = "devvit.plugin.redditapi.flair.Flair";
export class FlairClientImpl {
    constructor(rpc, opts) {
        this.service = opts?.service || FlairServiceName;
        this.rpc = rpc;
        this.ClearFlairTemplates = this.ClearFlairTemplates.bind(this);
        this.DeleteFlair = this.DeleteFlair.bind(this);
        this.DeleteFlairTemplate = this.DeleteFlairTemplate.bind(this);
        this.Flair = this.Flair.bind(this);
        this.FlairTemplateOrder = this.FlairTemplateOrder.bind(this);
        this.FlairConfig = this.FlairConfig.bind(this);
        this.FlairCsv = this.FlairCsv.bind(this);
        this.FlairList = this.FlairList.bind(this);
        this.FlairSelector = this.FlairSelector.bind(this);
        this.FlairTemplate = this.FlairTemplate.bind(this);
        this.LinkFlair = this.LinkFlair.bind(this);
        this.SelectFlair = this.SelectFlair.bind(this);
        this.SetFlairEnabled = this.SetFlairEnabled.bind(this);
        this.UserFlair = this.UserFlair.bind(this);
    }
    ClearFlairTemplates(request, metadata) {
        const data = ClearFlairTemplatesRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "ClearFlairTemplates", data, metadata);
        return promise.then((data) => JsonStatus.decode(_m0.Reader.create(data)));
    }
    DeleteFlair(request, metadata) {
        const data = DeleteFlairRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "DeleteFlair", data, metadata);
        return promise.then((data) => JsonStatus.decode(_m0.Reader.create(data)));
    }
    DeleteFlairTemplate(request, metadata) {
        const data = DeleteFlairTemplateRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "DeleteFlairTemplate", data, metadata);
        return promise.then((data) => JsonStatus.decode(_m0.Reader.create(data)));
    }
    Flair(request, metadata) {
        const data = FlairRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "Flair", data, metadata);
        return promise.then((data) => JsonStatus.decode(_m0.Reader.create(data)));
    }
    FlairTemplateOrder(request, metadata) {
        const data = FlairTemplateOrderRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "FlairTemplateOrder", data, metadata);
        return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
    }
    FlairConfig(request, metadata) {
        const data = FlairConfigRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "FlairConfig", data, metadata);
        return promise.then((data) => JsonStatus.decode(_m0.Reader.create(data)));
    }
    FlairCsv(request, metadata) {
        const data = FlairCsvRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "FlairCsv", data, metadata);
        return promise.then((data) => FlairCsvResponse.decode(_m0.Reader.create(data)));
    }
    FlairList(request, metadata) {
        const data = FlairListRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "FlairList", data, metadata);
        return promise.then((data) => FlairListResponse.decode(_m0.Reader.create(data)));
    }
    FlairSelector(request, metadata) {
        const data = FlairSelectorRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "FlairSelector", data, metadata);
        return promise.then((data) => FlairSelectorResponse.decode(_m0.Reader.create(data)));
    }
    FlairTemplate(request, metadata) {
        const data = FlairTemplateRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "FlairTemplate", data, metadata);
        return promise.then((data) => FlairObject.decode(_m0.Reader.create(data)));
    }
    LinkFlair(request, metadata) {
        const data = LinkFlairRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "LinkFlair", data, metadata);
        return promise.then((data) => FlairArray.decode(_m0.Reader.create(data)));
    }
    SelectFlair(request, metadata) {
        const data = SelectFlairRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "SelectFlair", data, metadata);
        return promise.then((data) => JsonStatus.decode(_m0.Reader.create(data)));
    }
    SetFlairEnabled(request, metadata) {
        const data = SetFlairEnabledRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "SetFlairEnabled", data, metadata);
        return promise.then((data) => JsonStatus.decode(_m0.Reader.create(data)));
    }
    UserFlair(request, metadata) {
        const data = LinkFlairRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "UserFlair", data, metadata);
        return promise.then((data) => FlairArray.decode(_m0.Reader.create(data)));
    }
}
export const FlairDefinition = {
    name: "Flair",
    fullName: "devvit.plugin.redditapi.flair.Flair",
    methods: {
        /** https://www.reddit.com/dev/api#POST_api_clearflairtemplates */
        clearFlairTemplates: {
            name: "ClearFlairTemplates",
            requestType: ClearFlairTemplatesRequest,
            requestStream: false,
            responseType: JsonStatus,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            40,
                            18,
                            38,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            112,
                            105,
                            47,
                            99,
                            108,
                            101,
                            97,
                            114,
                            102,
                            108,
                            97,
                            105,
                            114,
                            116,
                            101,
                            109,
                            112,
                            108,
                            97,
                            116,
                            101,
                            115,
                        ]),
                        new Uint8Array([2, 24, 4]),
                        new Uint8Array([2, 32, 1]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_deleteflair */
        deleteFlair: {
            name: "DeleteFlair",
            requestType: DeleteFlairRequest,
            requestStream: false,
            responseType: JsonStatus,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            32,
                            18,
                            30,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            112,
                            105,
                            47,
                            100,
                            101,
                            108,
                            101,
                            116,
                            101,
                            102,
                            108,
                            97,
                            105,
                            114,
                        ]),
                        new Uint8Array([2, 24, 4]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_deleteflairtemplate */
        deleteFlairTemplate: {
            name: "DeleteFlairTemplate",
            requestType: DeleteFlairTemplateRequest,
            requestStream: false,
            responseType: JsonStatus,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            40,
                            18,
                            38,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            112,
                            105,
                            47,
                            100,
                            101,
                            108,
                            101,
                            116,
                            101,
                            102,
                            108,
                            97,
                            105,
                            114,
                            116,
                            101,
                            109,
                            112,
                            108,
                            97,
                            116,
                            101,
                        ]),
                        new Uint8Array([2, 24, 4]),
                        new Uint8Array([2, 32, 1]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_flair */
        flair: {
            name: "Flair",
            requestType: FlairRequest,
            requestStream: false,
            responseType: JsonStatus,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            26,
                            18,
                            24,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            112,
                            105,
                            47,
                            102,
                            108,
                            97,
                            105,
                            114,
                        ]),
                        new Uint8Array([2, 24, 4]),
                        new Uint8Array([2, 32, 1]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /**
         * https://www.reddit.com/dev/api#PATCH_api_flair_template_order
         * Note: Endpoint expects body as raw array of flair id's
         */
        flairTemplateOrder: {
            name: "FlairTemplateOrder",
            requestType: FlairTemplateOrderRequest,
            requestStream: false,
            responseType: Empty,
            responseStream: false,
            options: {},
        },
        /** https://www.reddit.com/dev/api#POST_api_flairconfig */
        flairConfig: {
            name: "FlairConfig",
            requestType: FlairConfigRequest,
            requestStream: false,
            responseType: JsonStatus,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            32,
                            18,
                            30,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            112,
                            105,
                            47,
                            102,
                            108,
                            97,
                            105,
                            114,
                            99,
                            111,
                            110,
                            102,
                            105,
                            103,
                        ]),
                        new Uint8Array([2, 24, 4]),
                        new Uint8Array([2, 32, 1]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_flaircsv */
        flairCsv: {
            name: "FlairCsv",
            requestType: FlairCsvRequest,
            requestStream: false,
            responseType: FlairCsvResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            29,
                            18,
                            27,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            112,
                            105,
                            47,
                            102,
                            108,
                            97,
                            105,
                            114,
                            99,
                            115,
                            118,
                        ]),
                        new Uint8Array([2, 24, 4]),
                        new Uint8Array([2, 32, 1]),
                        new Uint8Array([2, 64, 1]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#GET_api_flairlist */
        flairList: {
            name: "FlairList",
            requestType: FlairListRequest,
            requestStream: false,
            responseType: FlairListResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 71, 69, 84]),
                        new Uint8Array([
                            117,
                            18,
                            115,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            112,
                            105,
                            47,
                            102,
                            108,
                            97,
                            105,
                            114,
                            108,
                            105,
                            115,
                            116,
                            46,
                            106,
                            115,
                            111,
                            110,
                            63,
                            97,
                            102,
                            116,
                            101,
                            114,
                            61,
                            123,
                            97,
                            102,
                            116,
                            101,
                            114,
                            125,
                            38,
                            98,
                            101,
                            102,
                            111,
                            114,
                            101,
                            61,
                            123,
                            98,
                            101,
                            102,
                            111,
                            114,
                            101,
                            125,
                            38,
                            99,
                            111,
                            117,
                            110,
                            116,
                            61,
                            123,
                            99,
                            111,
                            117,
                            110,
                            116,
                            125,
                            38,
                            108,
                            105,
                            109,
                            105,
                            116,
                            61,
                            123,
                            108,
                            105,
                            109,
                            105,
                            116,
                            125,
                            38,
                            110,
                            97,
                            109,
                            101,
                            61,
                            123,
                            110,
                            97,
                            109,
                            101,
                            125,
                            38,
                            115,
                            104,
                            111,
                            119,
                            61,
                            123,
                            115,
                            104,
                            111,
                            119,
                            125,
                        ]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_flairselector */
        flairSelector: {
            name: "FlairSelector",
            requestType: FlairSelectorRequest,
            requestStream: false,
            responseType: FlairSelectorResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            82,
                            18,
                            80,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            112,
                            105,
                            47,
                            102,
                            108,
                            97,
                            105,
                            114,
                            115,
                            101,
                            108,
                            101,
                            99,
                            116,
                            111,
                            114,
                            63,
                            110,
                            97,
                            109,
                            101,
                            61,
                            123,
                            110,
                            97,
                            109,
                            101,
                            125,
                            38,
                            108,
                            105,
                            110,
                            107,
                            61,
                            123,
                            108,
                            105,
                            110,
                            107,
                            125,
                            38,
                            105,
                            115,
                            95,
                            110,
                            101,
                            119,
                            108,
                            105,
                            110,
                            107,
                            61,
                            123,
                            105,
                            115,
                            95,
                            110,
                            101,
                            119,
                            108,
                            105,
                            110,
                            107,
                            125,
                        ]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                        new Uint8Array([2, 88, 1]),
                    ],
                },
            },
        },
        /**
         * https://www.reddit.com/dev/api#POST_api_flairtemplate_v2
         * Note: We ignore the "v1" implementation of this method
         * Beware: The JSON response to this endpoint is a FlairObject in camelCase, not snake_case
         * like the other responses.
         */
        flairTemplate: {
            name: "FlairTemplate",
            requestType: FlairTemplateRequest,
            requestStream: false,
            responseType: FlairObject,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            37,
                            18,
                            35,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            112,
                            105,
                            47,
                            102,
                            108,
                            97,
                            105,
                            114,
                            116,
                            101,
                            109,
                            112,
                            108,
                            97,
                            116,
                            101,
                            95,
                            118,
                            50,
                        ]),
                        new Uint8Array([2, 24, 4]),
                        new Uint8Array([2, 32, 1]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /**
         * https://www.reddit.com/dev/api#GET_api_link_flair_v2
         * Note: We ignore the "v1" implementation of this method
         */
        linkFlair: {
            name: "LinkFlair",
            requestType: LinkFlairRequest,
            requestStream: false,
            responseType: FlairArray,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 71, 69, 84]),
                        new Uint8Array([
                            34,
                            18,
                            32,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            112,
                            105,
                            47,
                            108,
                            105,
                            110,
                            107,
                            95,
                            102,
                            108,
                            97,
                            105,
                            114,
                            95,
                            118,
                            50,
                        ]),
                        new Uint8Array([2, 64, 1]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_selectflair */
        selectFlair: {
            name: "SelectFlair",
            requestType: SelectFlairRequest,
            requestStream: false,
            responseType: JsonStatus,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            32,
                            18,
                            30,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            112,
                            105,
                            47,
                            115,
                            101,
                            108,
                            101,
                            99,
                            116,
                            102,
                            108,
                            97,
                            105,
                            114,
                        ]),
                        new Uint8Array([2, 24, 4]),
                        new Uint8Array([2, 32, 1]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_setflairenabled */
        setFlairEnabled: {
            name: "SetFlairEnabled",
            requestType: SetFlairEnabledRequest,
            requestStream: false,
            responseType: JsonStatus,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            36,
                            18,
                            34,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            112,
                            105,
                            47,
                            115,
                            101,
                            116,
                            102,
                            108,
                            97,
                            105,
                            114,
                            101,
                            110,
                            97,
                            98,
                            108,
                            101,
                            100,
                        ]),
                        new Uint8Array([2, 24, 4]),
                        new Uint8Array([2, 32, 1]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                        new Uint8Array([2, 88, 1]),
                    ],
                },
            },
        },
        /**
         * https://www.reddit.com/dev/api#GET_api_user_flair_v2
         * Note: We ignore the "v1" implementation of this method
         */
        userFlair: {
            name: "UserFlair",
            requestType: LinkFlairRequest,
            requestStream: false,
            responseType: FlairArray,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 71, 69, 84]),
                        new Uint8Array([
                            34,
                            18,
                            32,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            112,
                            105,
                            47,
                            117,
                            115,
                            101,
                            114,
                            95,
                            102,
                            108,
                            97,
                            105,
                            114,
                            95,
                            118,
                            50,
                        ]),
                        new Uint8Array([2, 64, 1]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
    },
};
